import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid, Typography } from "@mui/material";
import { withStyles, WithStyles } from "@mui/styles";
import { GlobalClassKeys } from "assets/jss/common-styles";
import classNames from "classnames";
import { DashBoxStyles } from "components/Dashboard/DashBoxStyles";
import MuiColor from "components/MuiExtras/Typography/MuiColor";
import * as React from "react";

export interface DashProps {
    key: any;
    title: React.ReactNode;
    subtitle: React.ReactNode;
    description?: React.ReactNode;
    icon: IconDefinition;
    active?: boolean;
    color: "primary" | "secondary" | "error" | "info" | "success" | "warning" | "muted";
    contentColor?: "primary" | "secondary" | "error" | "info" | "success" | "warning";
    onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
}

type Props = DashProps & WithStyles<typeof DashBoxStyles>;

const DashBox: React.FC<Props> = (props) => {

    const { title, subtitle, description, icon, active, color, contentColor, classes, onClick } = props;

    var cls = classNames({
        [classes.root]: true,
        [classes[color]]: true,
        [classes.active]: active,
        [classes.cursor]: true
    });

    return (
        <div className={cls} onClick={onClick}>

            <MuiColor variant={contentColor == null ? "inherit" : contentColor}>

                <Grid container wrap="nowrap" spacing={2}>
                    <Grid item>
                        <FontAwesomeIcon icon={icon} size="3x" className={classes.icon} />
                    </Grid>
                    <Grid item xs>

                        <Grid container wrap="nowrap" justifyContent="space-between" alignItems="center" direction="column">
                            <Grid item xs zeroMinWidth>
                                <Typography variant="h5" noWrap={true}>{title}</Typography>
                            </Grid>
                            <Grid item xs zeroMinWidth>
                                <Typography component="div" noWrap={true} variant="subtitle2" className={GlobalClassKeys.textCenter}>{subtitle}</Typography>
                            </Grid>
                            <Grid item xs zeroMinWidth>
                                <MuiColor variant="muted">
                                    <Typography component="div" noWrap={true} variant="caption">{(description!= null)?description.toString().toLowerCase() : ""}</Typography>
                                </MuiColor>
                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>

            </MuiColor>
        </div>
    );
}

export default withStyles(DashBoxStyles)(DashBox);
